/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{ReadDepth as e}from"../output/ReadDepth.glsl.js";import{glsl as t}from"../../shaderModules/interfaces.js";import{Texture2DPassUniform as o}from"../../shaderModules/Texture2DPassUniform.js";function r(r){r.include(e),r.uniforms.add(new o("geometryDepthTexture",((e,t)=>t.multipassGeometry.depth?.attachment))),r.code.add(t`bool geometryDepthTest(vec2 pos, float elementDepth) {
float geometryDepth = linearDepthFromTexture(geometryDepthTexture, pos);
return (elementDepth < (geometryDepth - 1.0));
}`)}class m{}export{m as MultipassGeometryUniforms,r as multipassGeometryTest};
